export default __webpack_public_path__ + "static/media/package_4.d185b075.png";